import { Pet } from 'src/replicant/buruburu/pet';
import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import features from 'src/replicant/ruleset/features';
import StateObserver from 'src/StateObserver';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import { TutorialHandler } from './TutorialHandler';

export class AdultTutorial implements TutorialHandler {
  public readonly step: TutorialStep = 'adult';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'petEvolved') return false;

    const { user } = StateObserver.getState();

    if (
      !features(user).duo ||
      Pet.getters(user).getCurrentEvolution().stage !== 'adult'
    ) {
      return false;
    }

    await showTutorial('adult', {
      $stepIndex: 13,
      $stepName: 'become_adult',
    });

    return true;
  }
}
